import React from 'react';
import { Stack, StackItem } from '@domain-group/fe-blueprint-ui/layout';
import { AverageRatingText } from './average-star-rating-text';
import StarRatingDisplay from './components/star-rating-display';
import TotalReviewsText from './components/total-reviews-text';
import * as styles from './average-star-rating-and-total.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var AverageStarRatingAndTotal = _ref => {
  var size = _ref.size,
    _ref$averageRating = _ref.averageRating,
    averageRating = _ref$averageRating === void 0 ? 0 : _ref$averageRating,
    _ref$totalReviews = _ref.totalReviews,
    totalReviews = _ref$totalReviews === void 0 ? 0 : _ref$totalReviews;
  var sectionStyles = {
    starSize: size === 's' ? 12 : 16,
    verticalAlign: 'start',
    horizontalAlign: 'start',
    starGap: 1,
    strokeWidth: 5,
    fillBackground: 'none'
  };
  var starSize = sectionStyles.starSize,
    verticalAlign = sectionStyles.verticalAlign,
    horizontalAlign = sectionStyles.horizontalAlign,
    vertical = sectionStyles.vertical,
    fillStar = sectionStyles.fillStar,
    starGap = sectionStyles.starGap,
    strokeColor = sectionStyles.strokeColor,
    strokeWidth = sectionStyles.strokeWidth;
  return ___EmotionJSX(Stack, {
    css: styles.container,
    horizontalAlign: horizontalAlign,
    verticalAlign: verticalAlign,
    vertical: vertical,
    gap: "xxs",
    id: "star-rating"
  }, ___EmotionJSX(StackItem, {
    css: styles.ratings
  }, ___EmotionJSX(AverageRatingText, {
    size: size,
    value: averageRating
  }), ___EmotionJSX(StarRatingDisplay, {
    rating: averageRating,
    fillStar: fillStar,
    starSize: starSize,
    starGap: starGap,
    strokeColor: strokeColor,
    strokeWidth: strokeWidth
  }), totalReviews > 0 && ___EmotionJSX(TotalReviewsText, {
    totalReviews: totalReviews
  })));
};
export { AverageStarRatingAndTotal };